import { CircularProgress, Box, Typography } from '@mui/material';

export function ProgressStatusLoading({ label }: { label: string }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: 24, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={20} />
      </Box>
      <Typography sx={{ ml: 2 }}>{label}</Typography>
    </Box>
  );
}
